import { Module } from 'vuex'

import { JudgeStateModuleName, NotificationModuleName } from '../modules'

import { PostArenaSubmissionUseCase } from '@/application/arena/postArenaSubmissionUseCase'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface PostArenaSubmissionState {
  judgeToken: string
  isLoading: boolean
  error: string | null
}

export const postArenaSubmissionModule = (judgeRepository: JudgeRepository): Module<PostArenaSubmissionState, any> => {
  const postArenaSubmissionUseCase = new PostArenaSubmissionUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      judgeToken: '',
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeToken(state, token: string) {
        state.judgeToken = token
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async postArenaSubmission(
        { state, commit, dispatch },
        {
          problemId,
          arenaProblemId,
          arenaId,
          programLanguage,
          sourceCode
        }: {
          problemId: string
          arenaProblemId: string
          arenaId: string
          programLanguage: ProgramLanguageType
          sourceCode: string
        }
      ) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          // 通知を表示
          await dispatch(
            `${NotificationModuleName}/openRunningNotification`,
            { type: 'Judge', showFreeSpaceMode: false, problemId: problemId },
            { root: true }
          )
          // loadingをtrue
          await commit(`${JudgeStateModuleName}/setIsJudgeNotificationLoading`, true, { root: true })
          await commit(`${JudgeStateModuleName}/setIsJudgeLoading`, true, { root: true })

          const newProgramLanguage = programLanguage.replace(' (Beta)', '') as ProgramLanguageType

          const token = await postArenaSubmissionUseCase.postArenaSubmission(
            arenaProblemId,
            arenaId,
            newProgramLanguage,
            sourceCode
          )
          commit('setJudgeToken', token)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      judgeToken: state => state.judgeToken,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
